import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { Route, Switch, Redirect } from 'react-router-dom';
import { connect, PromiseState } from 'react-refetch';
import { addUrlProps, UrlQueryParamTypes, multiPushInUrlQuery } from 'react-url-query';

import FoodDetailTable from '../components/foodDetail/FoodDetailTable';
import ReportSelector from '../components/foodDetail/ReportSelector';
import NIP from '../components/foodDetail/NIP';
import Claimable from '../components/foodDetail/Claimable';
import Basic from '../components/foodDetail/Basic';
import FullAlphabetical from '../components/foodDetail/FullAlphabetical';
import FullGrouped from '../components/foodDetail/FullGrouped';
import PromiseStateContainer from '../components/apiAccess/PromiseStateContainer';
import FoodImage from '../components/presentation/FoodImage';
import Buttons from '../components/util/Buttons';
import { componentSets } from '../components/util/util';
import SearchNav from '../components/search/searchNav/SearchNav';
import PrintHeader from '../components/presentation/Print/PrintHeader';
import PrintDisclaimer from '../components/presentation/Print/PrintDisclaimer';

import BASE_URL from '../components/apiAccess/urls';
//import placeholder from '../assets/img/placeholder.png';
import placeholder from '../assets/img/food-placeholder-2.png';

import './foodDetail.css';

const urlPropsQueryConfig = {
  amount: { type: UrlQueryParamTypes.number },
};

class FoodDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      csvHeader: [],
      csvData: [],
    };

    this.setServingSize = this.setServingSize.bind(this);
    this.setCsvHeader = this.setCsvHeader.bind(this);
    this.setCsvData = this.setCsvData.bind(this);
    this.renderOnFulfillment = this.renderOnFulfillment.bind(this);
  }

  setServingSize(newServingSize) {
    multiPushInUrlQuery({
      amount: newServingSize,
    });
  }

  setCsvHeader(header) {
    this.setState({csvHeader: header});
  }

  setCsvData(newCsvData) {
    this.setState({csvData: newCsvData});
  }

  render() {
    const { foodFetch } = this.props;
    return (
      <PromiseStateContainer
        ps={PromiseState.all([foodFetch])}
        onFulfillment={this.renderOnFulfillment}
      />
    );
  }

  renderOnFulfillment([food]) {
    const recordid = this.props.match.params.recordid;
    const basePath = this.props.match.url;
    const currentPath = this.props.location.pathname;
    const currentReport = componentSets.find(componentSet => `${basePath}/${componentSet.key}` === currentPath);
    const currentReportTitle = currentReport ? currentReport.title : '';
    /*
    XXXXXXXXXXXXXXX
    Need to get this working with proper relative paths
    XXXXXXXXXXXXXXXXXXX
    */
    const foodpic = `/search/foodpics/${recordid}.jpg`;
    const urlQuery = {
      amount: this.props.amount,
    };
    const servingSize = typeof urlQuery.amount === 'number' ? urlQuery.amount : food.serving_size;

    // CSV configuration
    const csvReportName = currentReport ? currentReport.key : '';
    const csvServingSize = servingSize ? `--servingSize${servingSize}${food.unit || 'g'}` : '';
    const csvFilename = `${food.shortname}${csvServingSize}--${csvReportName}.csv`;

    return (
      <div className="FoodDetail">
        <Helmet title={`${food.shortname} - ${currentReportTitle} - New Zealand Food Composition Database`} />

        <div className="container">
          <PrintHeader title={currentReportTitle} />

          <SearchNav currentPath={this.props.match.url} />

          <div className="foodDetailHeader">
            <div className="foodNameContainer">
              <h2>Food details</h2>
              <h4 className="foodName">{food.shortname}</h4>
            </div>
            <div className="foodImageContainer">
              <FoodImage className="foodImage" src={foodpic} fallbackSrc={placeholder} alt={recordid} />
            </div>
          </div>

          <FoodDetailTable
            food={food}
            servingSize={servingSize}
            setServingSize={this.setServingSize}
          />

          <ReportSelector
            basePath={basePath}
            currentPath={currentPath}
            amount={urlQuery.amount}
          />
{/*
          <div className="Buttons">
            <PrintButton />
            <CSVButton
              header={this.state.csvHeader}
              data={this.state.csvData}
              filename={`${recordid}-${food.shortname} - ${currentReportTitle}.csv`}
            />
          </div> */}
          <Buttons
            csvHeader={this.state.csvHeader}
            csvData={this.state.csvData}
            filename={csvFilename}
          />

          <Switch>
            <Route path={`${basePath}/${componentSets[0].key}`} render={() => (
              <NIP
                recordid={recordid}
                servingSize={servingSize}
                setCsvHeader={this.setCsvHeader}
                setCsvData={this.setCsvData}
              />
            )} />
            <Route path={`${basePath}/${componentSets[1].key}`} render={() => (
              <Claimable
                recordid={recordid}
                servingSize={servingSize}
                setCsvHeader={this.setCsvHeader}
                setCsvData={this.setCsvData}
              />
            )} />
            <Route path={`${basePath}/${componentSets[2].key}`} render={() => (
              <Basic
                recordid={recordid}
                servingSize={servingSize}
                setCsvHeader={this.setCsvHeader}
                setCsvData={this.setCsvData}
              />
            )} />
            <Route path={`${basePath}/${componentSets[3].key}`} render={() => (
              <FullAlphabetical
                recordid={recordid}
                servingSize={servingSize}
                setCsvHeader={this.setCsvHeader}
                setCsvData={this.setCsvData}
              />
            )} />
            <Route path={`${basePath}/${componentSets[4].key}`} render={() => (
              <FullGrouped
                recordid={recordid}
                servingSize={servingSize}
                setCsvHeader={this.setCsvHeader}
                setCsvData={this.setCsvData}
              />
            )} />
            <Route render={() => (
              <Redirect to={`${basePath}/${componentSets[0].key}`} />
            )} />
          </Switch>

          {/* <div className='printFooter'>
            <small>
              DISCLAIMER: Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Fusce metus enim, interdum at dui ut, interdum vestibulum ex.
              Curabitur lacinia aliquam massa eget lacinia. Sed porta eros tincidunt
              dignissim tincidunt. Curabitur dapibus et elit vitae auctor. Nulla
              ut semper diam. In hac habitasse platea dictumst. Ut eget euismod nunc.
            </small>
          </div> */}
          <PrintDisclaimer />
        </div>
      </div>
    );
  }
}

FoodDetail.propTypes = {
  foodFetch: PropTypes.instanceOf(PromiseState),
  match: PropTypes.object,
  location: PropTypes.object,
  amount: PropTypes.number,
  onChangeAmount: PropTypes.func,
};

const fetch = (props) => ({
  foodFetch: `${BASE_URL}/food/${props.match.params.recordid}`,
});

export default addUrlProps({ urlPropsQueryConfig })(connect(fetch)(FoodDetail));



// WEBPACK FOOTER //
// ./src/views/foodDetail.js